import {
  Box,
  LinearProgress,
  Stack,
  Text,
  useTheme,
} from '@ltvco/refresh-lib/theme';

export type ReportUsage = {
  reportsRun: number;
  reportsLimit: number;
  progressValue: number;
};

type ReportUsageSectionProps = {
  usage: ReportUsage;
};

// Padding mirrors UserInfoSection (py: 1.5, px: 2) so the usage block lines up
// with the other modal sections instead of looking like the standalone sidebar
// card it replaced. The "Upgrade" action lives in UpgradeSection below, so this
// section is display-only.
export const ReportUsageSection = ({ usage }: ReportUsageSectionProps) => {
  const theme = useTheme();
  const { reportsRun, reportsLimit, progressValue } = usage;

  return (
    <Stack spacing={1} sx={{ py: 1.5, px: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Text variant="body2" sx={{ fontWeight: 700 }}>
          Reports
        </Text>
        <Text
          variant="caption"
          sx={{ fontWeight: 700, color: theme.palette.text.secondary }}
        >
          {reportsRun}/{reportsLimit} left
        </Text>
      </Box>
      <LinearProgress
        value={progressValue}
        variant="determinate"
        sx={{
          height: theme.spacing(1),
          borderRadius: theme.spacing(0.5),
        }}
      />
    </Stack>
  );
};
